import TableWithFilter from 'components/InternalRequest/Summary/tableWithFilter'

export default function AllRequest() {
  return <TableWithFilter pageInset={205} retainFilter={true} tab={'allrequest'} />
}
